export const goldAssetsLanguages = {
  planName: 'نام طرح',
  myInvestmjentCombination: 'ترکیب سرمایه گذاری من',
  gold: 'طلا',
  Description: 'توضیحات',
  assetValue: 'ارزش دارایی شما ',
  CurrentProfit_loss: 'سود/ زیان فعلی',
  goldPaln: 'طرح طلا',
  requestHistory: 'سابقه درخواست',
  assets: 'دارایی',
  goldweight: 'وزن طلا',
  buyGoldweight: 'وزن طلای خریداری شده',
  sellGoldweight: 'وزن طلای فروخته شده',
  requestAmount: 'مبلغ درخواست',
  status: 'وضعیت',
  requestType: 'نوع درخواست',
  submitTime: 'تاریخ و زمان ثبت',
  trackingCode: 'کد پیگیری',
  buyDetails: 'جزئیات خرید',
  sellDetails: 'جزئیات واریز',
  paymentType: 'نحوه پرداخت ',
  paymentAmount: 'مبلغ پرداخت‌شده',
  finalPriceBuy: 'قیمت طلا پس از پرداخت (هر میلی گرم)',
  finalPriceSell: 'قیمت طلا در هنگام فروش (هر میلی گرم)',
  fee: 'کارمزد',
  buy_fee: 'کارمزد خرید',
  sell_fee: 'کارمزد فروش (٪۱)',
  payment_date: 'تاریخ واریز',
  next_day: 'اولین روز کاری آینده',
  finalAmount: 'مبلغ نهایی',
  sellFinalAmount: 'مبلغ نهایی واریز',
  amount: 'مبلغ',
  orderAmount: 'مبلغ فروش',
  totalRecieveAmount: 'کل مبلغ دریافتی',
  destinationBankAccountInformation: 'اطلاعات حساب مقصد',
  bank: 'بانک',
  accountNumber: 'شماره شبا ',
  notice: 'مبلغ نهایی، در اولین روز کاری پس از ثبت درخواست به حساب شما واریز می‌شود.',
  geram: 'گرم',
  miliGeram: 'میلی گرم',
  rial: 'ریالءء',
  DrawerTitleBuy: 'ثبت درخواست خرید',
  DrawerTitleSell: 'فروش طلا',
  currentPriceCalc: 'قیمت در لحظه‌ محاسبه (هر میلی گرم)',
  buyAmount: 'مبلغ',
  sellAmount: 'مبلغ فروش',
  confirmAccuracyInformation: 'درستی اطلاعات زیر را تایید می‌کنید؟',
  RequestInformation: 'اطلاعات درخواست',
  confirm: 'تایید',
  finalPrice: 'مبلغ نهایی',
  rialValue: 'ارزش ریالی',
  goldValue: 'مقدار طلا',
  prevState: 'مرحله قبل',
  submitBuyRequest: 'ثبت درخواست خرید',
  confrimBuyRequest: ' تایید درخواست خرید',
  formLabel: 'مبلغ یا وزن طلای مورد نظرتان را وارد کنید',
  buyNotice: (
    <p className='font-normal text-[13px] text-icons'>
      * مقدار <span className='text-text font-semibold'>گرم</span> طلای شما{' '}
      <span className='text-text font-semibold'>پس از بازگشت از درگاه</span> پرداخت اینترنتی و بر
      اساس قیمت لحظه‌ای طرح طلا محاسبه می‌شود.
    </p>
  ),
  sellNotice: (
    <p className='font-normal text-[13px] text-icons'>
      * محاسبه دقیق <span className='text-text font-semibold'>میزان فروش طلای گرمی</span> شما براساس
      قیمت لحظه‌ای طرح طلا پس از <span className='text-text font-semibold'>تایید درخواست فروش</span>{' '}
      انجام خواهد شد.
    </p>
  ),
  submitSellRequest: 'ثبت درخواست فروش',
  confrimSellRequest: 'تایید درخواست فروش',
  sellRequestStatus: 'وضعیت درخواست فروش',
  buyRequestStatus: 'وضعیت درخواست خرید',
  bankSelect: 'انتخاب حساب بانکی',
  sellBankSelectNotice: '* مبلغ حاصل از فروش، در روز کاری آینده به حساب شما واریز می‌شود.',
  payment_amount: 'مبلغ واریزی',
  gold_amount: 'مبلغ طلا',
  request_status: 'وضعیت درخواست',
  request_histories: 'سابقه درخواست‌ها',
  dashboard: 'داشبورد',
  sell_success_message:
    'درخواست فروش طلای ۲۴ عیار شما با <span class="text-green-1">موفقیت</span> ثبت شد.',
  buy_success_message:
    'درخواست خرید طلای ۲۴ عیار شما با <span class="text-green-1">موفقیت</span> ثبت شد.',
  buy_failed_message: 'درخواست خرید طلای ۲۴ عیار شما <span class="text-red-1">ناموفق</span> بود.',
  sell_success_notice:
    'وجه حاصل از فروش، در اولین روز کاری آینده به حساب بانکی شما واریز خواهد شد.',
  buy_success_notice:
    'شما می‌توانید مقدار دقیق طلای خریداری شده را در سابقه درخواست‌ها مشاهده کنید.',
  buy_failed_notice:
    'چنانچه مبلغی از حساب شما کسر شده است، تا ۷۲ ساعت آینده به حساب شما باز خواهد گشت',
  tracking_number: 'شماره پیگیری',
  reqestDetails: 'جزئیات درخواست',
  try_buy_again: 'خرید مجدد',
  goldPlanInvestment: 'سرمایه‌گذاری در طرح طلا',
  sellOrderTooltip:
    'با توجه به قیمت طلا، به منظور اینکه مبلغ درخواستی به شما پرداخت گردد، میزان فروش ممکن است چند ریال بیشتر از مبلغ درخواستی شما باشد.',
  emptyStateText: 'سبد دارایی شما خالی است.',
};

export const goldAssetCard = {
  title: 'ارزش دارایی شما',
  milligram: 'میلی‌گرم',
  rial: 'ریالءء',
};

export const goldTrade = {
  investmentGold24: 'طرح سرمایه گذاری طلا 24 عیار',
  BuyGoldAnyTimeOfDay: 'خرید طلا در هر لحظه از شبانه‌روز',
  CurrentPrice24gold: 'قیمت لحظه‌ای هر گرم طلای ۲۴ عیار',
  SellGoldAnyTimeOfDay: 'فروش طلا در هر لحظه از شبانه‌روز',
};
